import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    textAlign: 'left',
    margin: theme.spacing(4, 0, 0, 0),
  },
  percentageDiscount: {
    marginTop: theme.spacing(3),
    width: '100%',
    fontSize: '13px',
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '13px !important',
      paddingBottom: theme.spacing(1.5),
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px !important',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
  },
}))
